import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export function RerunPanel({ token, jobCode }) {
  const [url, setUrl] = useState("");
  const [notes, setNotes] = useState("");
  const [busy, setBusy] = useState(false);

  async function go() {
    if (!/^https?:\/\//.test(url.trim())) { toast.error("Enter the new build link or URL (https://…)"); return; }
    setBusy(true);
    try {
      const r = await api.rerun(token, { app_url: url.trim(), notes, origin_url: window.location.origin });
      window.location.href = r.checkout_url;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not start the re-run");
      setBusy(false);
    }
  }

  return (
    <section className="panel-soft" style={{ padding: "24px 26px", marginTop: 32 }} data-testid="rerun-panel">
      <span className="eyebrow" style={{ color: "var(--blue)", fontWeight: 600 }}>Test the fix</span>
      <h2 style={{ fontSize: 26, marginBottom: 6 }}>Re-run the same plan on a new build.</h2>
      <p className="muted" style={{ margin: "0 0 16px", maxWidth: "60ch" }}>Same test cases, same device targets, same package price. Paste the new build link, pay, and testers are on it within the hour — no form to fill again. Any credit on your email from unfilled sessions is applied automatically.</p>
      <div className="row">
        <div className="field"><label>New build link or URL</label><input data-testid="rerun-url" placeholder="https://play.google.com/apps/internaltest/… or https://staging.example.com" value={url} onChange={(e) => setUrl(e.target.value)} /></div>
        <div className="field"><label>What changed (optional)</label><input data-testid="rerun-notes" placeholder="Fixed cart loss on UPI app switch" value={notes} onChange={(e) => setNotes(e.target.value)} /></div>
      </div>
      <button className="btn blue" data-testid="rerun-submit" disabled={busy} onClick={go}>{busy ? "Starting checkout…" : `Re-run ${jobCode} on this build`}</button>
    </section>
  );
}
